/**
 * useDailyRituals Hook
 * Fetches active practice rituals for the daily rituals carousel.
 * Uses existing practices endpoint, returns first N rituals.
 */

import { useQuery } from "@tanstack/react-query"
import { getUserRitualPractices } from "@/features/profile/services/user-rituals.service"

export function useDailyRituals(userId: string) {
  return useQuery({
    queryKey: ["dailyRituals", userId],
    queryFn: () => getUserRitualPractices(userId, { page: 1, limit: 10 }),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
